import { render, staticRenderFns } from "./DocumentsBox.vue?vue&type=template&id=9b87f230&scoped=true"
import script from "./DocumentsBox.vue?vue&type=script&lang=js"
export * from "./DocumentsBox.vue?vue&type=script&lang=js"
import style0 from "./DocumentsBox.vue?vue&type=style&index=0&id=9b87f230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b87f230",
  null
  
)

export default component.exports